export const EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
